<template lang="pug">
fragment
  dt(style="background-color: cornsilk;")
    | 事前アンケート
  dd(style="background-color: cornsilk;")
    | 映像制作についてのアンケートにお答えください
  dt.required
    | 今回何を見てこのイベントに申込ましたか？
  dd
    div
      validation-provider(rules="required" name="今回何を見てこのイベントに申込ましたか" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(lookAtWhat, i) in lookAtWhats" :key="i")
            input(type="radio" v-model="enquete.look_at_what" :value="lookAtWhat" :id="`look_at_what-${i}`")
            label(:for="`look_at_what-${i}`")
              | {{ lookAtWhat }}
            template(v-if="lookAtWhat === 'その他'")
              validation-provider(:rules="{ required: isOtherRequired(`look_at_what-${i}`) }" name="その他を選択時" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.look_at_what_other" :class="{ error: invalid && validated }")

  dt.required
    | 最も使用頻度が高い撮影機材を１つ選択してください。
  dd
    div
      validation-provider(rules="required" name="最も使用頻度が高い撮影機材" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .caption
            | 「ミラーレスカメラ」を選択する場合はメーカー名 /品番を記載して下さい。
            br
            | （記載例：Nikon Z 30 、SONY VLOGCAM ZV-E1、Canon EOS Kiss X90　等）
          .v-radio(v-for="(equipment, i) in equipments" :key="i")
            input(type="radio" v-model="enquete.equipment" :value="equipment" :id="`equipment-${i}`")
            label(:for="`equipment-${i}`")
              | {{ equipment }}
            template(v-if="equipment === 'ミラーレスカメラ'")
              validation-provider(:rules="{ required: isOtherRequired(`equipment-${i}`) }" name="ミラーレスカメラ選択時" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.equipment_mirrorless_camera" :class="{ error: invalid && validated }")
            template(v-if="equipment === 'その他'")
              validation-provider(:rules="{ required: isOtherRequired(`equipment-${i}`) }" name="その他" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.equipment_other" :class="{ error: invalid && validated }")

  dt.required
    | SNSでの動画投稿を行っていますか？
    br
    | 行っている場合は、最も使用しているものを１つ選択してください
  dd
    div
      validation-provider(rules="required" name="SNSでの動画投稿" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .caption
          .v-radio(v-for="(snsVideoPost, i) in snsVideoPosts" :key="i")
            input(type="radio" v-model="enquete.sns_video_post" :value="snsVideoPost" :id="`snsVideoPost-${i}`")
            label(:for="`snsVideoPost-${i}`")
              | {{ snsVideoPost }}
            template(v-if="snsVideoPost === 'その他'")
              validation-provider(:rules="{ required: isOtherRequired(`snsVideoPost-${i}`) }" name="その他を選択時" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.sns_video_post_other" :class="{ error: invalid && validated }")

  dt(:class="enquete.sns_video_post !== 'していない' ? 'required' : 'optional'")
    | 発信しているSNSアカウントを記載してください。
  dd
    div
      validation-provider(:rules="{ required: enquete.sns_video_post !== 'していない' }" name="発信しているSNSアカウント" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .caption
            | アクセスすることが可能なアカウントURLを記載してください。「鍵アカ」は無効です。
          .job-form-point
            | 例：
            br
            | instagramの場合：https://www.instagram.com/vookschool/
            br
            | Twitterの場合：https://twitter.com/VookJp
            br
            | Facebookの場合：https://www.facebook.com/VookJp/
            br
            | YouTubeの場合：https://www.youtube.com/channel/UCwQ0VT8WWOT5Nvcg5Q43zxA　など
          textarea(id="sns_account" v-model="enquete.sns_account")

  dt(:class="enquete.sns_video_post !== 'していない' ? 'required' : 'optional'")
    | 動画のSNS発信を行っていると回答した方はお答えください。
    br
    | 普段撮影しているジャンルを１つ選択してください
  dd
    div
      validation-provider(:rules="{ required: enquete.sns_video_post !== 'していない' }" name="撮影しているジャンル" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .caption
          .v-radio(v-for="(shootingGenre, i) in shootingGenres" :key="i")
            input(type="radio" v-model="enquete.shooting_genre" :value="shootingGenre" :id="`shootingGenre-${i}`")
            label(:for="`shootingGenre-${i}`")
              | {{ shootingGenre }}
            template(v-if="shootingGenre === 'その他'")
              validation-provider(:rules="{ required: isOtherRequired(`shootingGenre-${i}`) }" name="その他を選択時" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.shooting_genre_other" :class="{ error: invalid && validated }")

  dt.required
    | 今回のイベントに参加する目的を３つまで選択してください
  dd
    div
      validation-provider(:rules="{ required: true, maxCount: 3 }" name="イベントに参加する目的" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .caption
          .job-form-point
          .v-checkbox(v-for="(attendTarget, i) in attendTargets" :key="i")
            input(type="checkbox" v-model="enquete.attend_targets" :value="attendTarget" :id="`attendTarget-${i}`")
            label(:for="`attendTarget-${i}`")
              | {{ attendTarget }}
            template(v-if="attendTarget === 'その他'")
              validation-provider(:rules="{ required: isOtherRequired(`attendTarget-${i}`) }" name="その他を選択時" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.attend_target_other" :class="{ error: invalid && validated }")

  dt.required
    | どんなリールをつくりたいですか？
  dd
    div
      validation-provider(rules="required" name="どんなリールをつくりたいですか" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .caption
          .job-form-point
          textarea(id="reel" v-model="enquete.reel")

  dt.required
    | 参加への意気込みを一言どうぞ！
  dd
    div
      validation-provider(rules="required" name="参加への意気込みを一言どうぞ" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .caption
          .job-form-point
          textarea(id="enthusiasm" v-model="enquete.enthusiasm")

</template>

<script>
import { Fragment } from 'vue-fragment'
import FormTextInput from '~/components/FormTextInput'
import FormTextarea from '~/components/FormTextarea'

const LOOK_AT_WHATS = [
  'Vookのホームページ',
  'VookのX(元Twitter)',
  'VookのInstagram',
  'NikonのX(元Twitter)',
  '上記以外のX(元Twitter)でフォロー中のアカウント',
  '上記以外のInstagramでフォロー中のアカウント',
  'その他'
]

const EQUIPMENTS = [
  'スマートフォン,タブレットPC',
  'ミラーレスカメラ',
  'アクションカム',
  'その他'
]

const SNS_VIDEO_POSTS = [
  'Instagram・リール',
  'YouTube・ショート',
  'X (元Twitter)',
  'TikTok',
  'Threads',
  'LINE',
  'その他',
  'していない'
]

const SHOOTING_GENRES = [
  '風景',
  'スナップ',
  '人物',
  '旅',
  'ドキュメンタリー',
  '広告(企業VP)',
  'ミュージックビデオ',
  'Vlog',
  '動物',
  '料理',
  'スポーツ',
  'ウエディング',
  'その他'
]

const ATTEND_TARGETS = [
  'カメラできれいな動画を撮りたい',
  'おしゃれなリールを作れるようになりたい',
  '動画撮影の基礎を学びたい',
  '動画編集の基礎を学びたい',
  'ビデオグラファーから直接教えてもらいたい',
  '1Dayで映像制作を身に着けたい',
  'リアル開催のイベントのため',
  '1人1台カメラをレンタルできるため',
  '参加者とのコミュニケーションを取りたい',
  'その他'
]

export default {
  components: {
    FormTextInput,
    FormTextarea,
    Fragment
  },
  data() {
    return {
      enquete: {
        look_at_what: null,
        look_at_what_other: null,
        equipment: null,
        equipment_mirrorless_camera: null,
        equipment_other: null,
        sns_video_post: null,
        sns_video_post_other: null,
        sns_account: null,
        shooting_genre: null,
        shooting_genre_other: null,
        attend_targets: [],
        attend_target_other: null,
        reel: null,
        enthusiasm: null
      }
    }
  },
  computed: {
    lookAtWhats() {
      return LOOK_AT_WHATS
    },
    equipments() {
      return EQUIPMENTS
    },
    snsVideoPosts() {
      return SNS_VIDEO_POSTS
    },
    shootingGenres() {
      return SHOOTING_GENRES
    },
    attendTargets() {
      return ATTEND_TARGETS
    }
  },
  watch: {
    'enquete.look_at_what': {
      handler() {
        if (this.enquete.look_at_what !== 'その他') {
          this.enquete.look_at_what_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.look_at_what_other': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.equipment': {
      handler() {
        if (this.enquete.equipment !== 'ミラーレスカメラ') {
          this.enquete.equipment_mirrorless_camera = null
        }
        if (this.enquete.equipment !== 'その他') {
          this.enquete.equipment_mirrorless_camera = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.equipment_mirrorless_camera': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.equipment_other': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.sns_video_post': {
      handler() {
        if (this.enquete.sns_video_post !== 'その他') {
          this.enquete.sns_video_post_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.sns_video_post_other': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.sns_account': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.shooting_genre': {
      handler() {
        if (this.enquete.shooting_genre !== 'その他') {
          this.enquete.shooting_genre_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.shooting_genre_other': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.attend_targets': {
      handler() {
        if (!this.enquete.attend_targets.includes('その他')) {
          this.enquete.attend_target_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.attend_target_other': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.reel': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.enthusiasm': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    }
  },
  mounted() {
    const enqueteCookie = this.$cookies.get('entryEventEnquete')
    if (enqueteCookie) {
      this.enquete = enqueteCookie
    }
  },
  methods: {
    isOtherRequired(id) {
      if (process.browser) {
        const element = document.getElementById(id)
        if (element) {
          return element.checked
        }
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.job-form-point {
  font-size: 0.85em;
  opacity: 0.9;
  line-height: 1.4;
}
</style>
